export const LEARN_MORE_URL = 'https://yandex.ru/support2/rythm/ru/author/cpa';

export const PARTNER_REGISTRATION_PATH = '/partner/registration';
